import styled from 'styled-components';

import { RichText } from '../ui';

export const SessionModalRichText = styled(RichText)`
  margin-bottom: 2rem;
`;

export const SessionModalButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
